var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "" } },
            [
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div1" }, [_vm._v("基本配置")]),
              ]),
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div2" }, [_vm._v("店铺权限设置")]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "manage" }, [
        _c("h2", [_vm._v("店铺权限设置")]),
        _c("p", { staticClass: "header" }, [_vm._v("数据列表")]),
        _c("div", { staticClass: "btn-list" }, [
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  attrs: {
                    disabled: _vm.loading,
                    plain: "",
                    type: _vm.currentTab === "all" ? "primary" : "info",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.onChangeStatus("all")
                    },
                  },
                },
                [
                  _vm._v(
                    "全部(" + _vm._s(_vm.shopStatistics.totalCount || 0) + ") "
                  ),
                ]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    disabled: _vm.loading,
                    plain: "",
                    type: _vm.currentTab === "ing" ? "primary" : "info",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.onChangeStatus("ing")
                    },
                  },
                },
                [
                  _vm._v(
                    "营业中(" + _vm._s(_vm.shopStatistics.openCount || 0) + ") "
                  ),
                ]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    disabled: _vm.loading,
                    plain: "",
                    type: _vm.currentTab === "close" ? "primary" : "info",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.onChangeStatus("close")
                    },
                  },
                },
                [
                  _vm._v(
                    "关闭(" + _vm._s(_vm.shopStatistics.closedCount || 0) + ") "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "table",
          },
          [
            _c(
              "vxe-table",
              {
                attrs: {
                  align: "center",
                  "keep-source": "",
                  data: _vm.tableData.list,
                },
              },
              [
                _c("vxe-table-column", {
                  attrs: { title: "序号", field: "rowNum", width: "60" },
                }),
                _c("vxe-table-column", {
                  attrs: {
                    field: "shopName",
                    title: "店铺名称",
                    minWidth: "195",
                  },
                }),
                _c("vxe-table-column", {
                  attrs: { title: "店铺ID", field: "shopId", width: "80" },
                }),
                _c("vxe-table-column", {
                  attrs: {
                    title: "店铺状态",
                    field: "shopStatus",
                    width: "80",
                  },
                }),
                _c("vxe-table-column", {
                  attrs: {
                    title: "所属平台",
                    field: "platformName",
                    width: "110",
                  },
                }),
                _c("vxe-table-column", {
                  attrs: { title: "查看权限", minWidth: "195" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                "value-key": "userId",
                                placeholder: "选择查看权限",
                                "collapse-tags": "",
                                size: "small",
                                multiple: "",
                                "popper-class": "hidden",
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.openUserPicker(
                                    "viewUser",
                                    scope.row
                                  )
                                },
                              },
                              model: {
                                value: scope.row.viewUsers,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "viewUsers", $$v)
                                },
                                expression: "scope.row.viewUsers",
                              },
                            },
                            _vm._l(scope.row.viewUsers, function (user, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: user.realName, value: user },
                              })
                            }),
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("vxe-table-column", {
                  attrs: { title: "操作权限", minWidth: "195" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                "value-key": "userId",
                                placeholder: "选择操作权限",
                                "collapse-tags": "",
                                size: "small",
                                multiple: "",
                                "popper-class": "hidden",
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.openUserPicker(
                                    "operateUser",
                                    scope.row
                                  )
                                },
                              },
                              model: {
                                value: scope.row.operateUsers,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "operateUsers", $$v)
                                },
                                expression: "scope.row.operateUsers",
                              },
                            },
                            _vm._l(
                              scope.row.operateUsers,
                              function (user, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: { label: user.realName, value: user },
                                })
                              }
                            ),
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("vxe-table-column", {
                  attrs: { field: "orderSyncStatus", width: "100" },
                  scopedSlots: _vm._u([
                    {
                      key: "header",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "title-word-break" }, [
                            _vm._v("订单是否"),
                            _c("br"),
                            _vm._v("已同步系统"),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _c("div", { staticClass: "page" }, [
              _c(
                "div",
                { staticClass: "block" },
                [
                  _c("el-pagination", {
                    attrs: {
                      background: "",
                      "current-page": _vm.currentPage,
                      "page-size": 10,
                      layout: "total, prev, pager, next",
                      total: _vm.tableData.totalNum,
                    },
                    on: {
                      "current-change": _vm.handleCurrentChange,
                      "update:currentPage": function ($event) {
                        _vm.currentPage = $event
                      },
                      "update:current-page": function ($event) {
                        _vm.currentPage = $event
                      },
                    },
                  }),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ]),
      _c("org-picker", {
        ref: "orgPicker",
        attrs: { title: _vm.pickTitle, multiple: true },
        on: { ok: _vm.selectedUser },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }